import React from 'react';

const AtAGlanceSummary = ({ items }) => {
  return (
    <div className="bg-gray-900/60 border border-purple-500/30 rounded-lg p-6 mb-10" data-testid="at-a-glance">
      <h2 className="text-sm font-bold text-purple-400 uppercase tracking-wider mb-3">At a Glance</h2>
      <ul className="space-y-2 text-gray-300 text-sm">
        {items.map((item, i) => (
          <li key={i} className="flex gap-2">
            <span className="text-purple-400 mt-0.5">&#8226;</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AtAGlanceSummary;
